import { uiRows } from './types-def.js';
/** `web/links` (1.J): the Story panel. */
export const LINKS_INTERACTIONS = uiRows([
    {
        id: 'story.reorder.drag',
        module: 'web/links',
        behavior: 'Dragging a Story panel row reorders it and changes only link.position',
        owner: '1.J',
        since: 'exit-1a',
    },
    {
        id: 'story.reorder.keys',
        module: 'web/links',
        behavior: 'Alt-Shift-Up and Alt-Shift-Down reorder a row and change only link.position',
        owner: '1.J',
        since: 'exit-1a',
    },
    {
        id: 'story.row.menu',
        module: 'web/links',
        behavior: 'The row menu offers make home, optional and remove, and each works',
        owner: '1.J',
        since: 'exit-1a',
    },
    {
        id: 'story.add.pick-or-create',
        module: 'web/links',
        behavior: '"+ Add" picks an existing document or creates one; a new quest without a home takes this arc',
        owner: '1.J',
        since: 'exit-1a',
    },
    {
        id: 'story.order.mismatch-badge',
        module: 'web/links',
        behavior: '"Compare in-world order" shows mismatch badges where narrative and in-world order differ',
        owner: '1.J',
        // Re-dated by decision 31 (1.0b deliverable 15).
        since: 'exit-1b',
    },
    {
        id: 'story.row.validity',
        module: 'web/links',
        behavior: 'The row menu sets when the link holds in in-world time, and the row shows it',
        owner: '1.J',
        since: 'exit-1b',
    },
]);
//# sourceMappingURL=links.js.map